module.exports = __webpack_public_path__ + "static/img/culture4.49b6383.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/culture4.png
// module id = M3EE
// module chunks = 2